import { memoizeOne } from '../../common/utils/memoize-one';
// This code breaks when used in compoent ssr (atob beeing undefined), so 'parseInstance'
// can be used only in controller
const atob = typeof self !== 'undefined'
    ? self.atob.bind(self)
    : (str) => global.Buffer.from(str, 'base64').toString('utf8');
// Wrapped in memoizeOne to feel more cozy while using it repeatedly
export const parseInstance = memoizeOne((instance) => {
    const [, base64data] = instance.split('.', 2);
    const data = atob(base64data);
    return JSON.parse(data);
});
//# sourceMappingURL=parse-instance.js.map